"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Layer = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M.3 4.03l5.4 2.972a.626.626 0 00.6 0l5.4-2.971a.567.567 0 00.3-.492.567.567 0 00-.3-.497L6.3.077a.626.626 0 00-.6 0L.3 3.042a.567.567 0 00-.3.497c.002.203.116.39.3.492zM6 1.255l4.2 2.285L6 5.825 1.8 3.54 6 1.254zm5.1 4.097L6 8.11.9 5.328a.626.626 0 00-.457-.057.597.597 0 00-.365.268.557.557 0 00.222.778l5.4 2.971a.626.626 0 00.6 0l5.4-2.971a.557.557 0 00.222-.778.597.597 0 00-.364-.268.626.626 0 00-.458.057v.023zm0 2.286L6 10.397.9 7.614a.626.626 0 00-.457-.058.597.597 0 00-.365.27.557.557 0 00.222.776l5.4 2.972a.626.626 0 00.6 0l5.4-2.972a.557.557 0 00.222-.777.597.597 0 00-.364-.269.626.626 0 00-.458.058v.023z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M11.1 5.35L6 8.11.9 5.329a.626.626 0 00-.457-.057.597.597 0 00-.365.268.557.557 0 00.222.778l5.4 2.971a.626.626 0 00.6 0l5.4-2.971a.557.557 0 00.222-.778.597.597 0 00-.364-.268.626.626 0 00-.458.057v.023z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M11.1 7.637L6 10.397.9 7.614a.626.626 0 00-.457-.058.597.597 0 00-.365.27.557.557 0 00.222.776l5.4 2.972a.626.626 0 00.6 0l5.4-2.972a.557.557 0 00.222-.777.597.597 0 00-.364-.269.626.626 0 00-.458.058v.023z"
})));
var _default = exports.default = Layer;